import {
  userRole
} from '@/lib/filters/user/role'
import {USER, TECHNICAL_ADMINISTRATOR, PROJECT_MANAGER, CCE} from '@/lib/enums/user/role'
import { userStatus } from '@/lib/filters/user/status'

class User {
  static get modelName () {
    return 'User' // Fait le lien avec src\resources\ability.js
  }

  constructor ({
    uid,
    cityName,
    departmentNumber,
    departmentName,
    creationDate,
    lastLoginDate,
    validationDate,
    version,
    username,
    firstname,
    lastname,
    email,
    cityId,
    phoneNumber,
    insee,
    role,
    status,
    favorites,
    rolesManager
  }) {
    this.uid = uid
    this.cityName = cityName
    this.departmentNumber = departmentNumber
    this.departmentName = departmentName
    this.creationDate = creationDate
    this.lastLoginDate = lastLoginDate
    this.validationDate = validationDate
    this.version = version
    this.username = username
    this.firstname = firstname
    this.lastname = lastname
    this.email = email
    this.cityId = cityId
    this.favoriteSites = favorites
    this.insee = insee
    this.phoneNumber = phoneNumber
    this.role = {
      code: role,
      libelle: userRole[role]
    }
    this.status = {
      code: status,
      libelle: userStatus[status]
    }
    this.rolesManager = rolesManager
  }
  equal (uid) {
    return this.uid === uid
  }
  initials () {
    if (this.lastname && this.firstname) {
      return (this.lastname.charAt(0) + this.firstname.charAt(0)).toUpperCase()
    } else {
      return '?'
    }
  }
  isBackOfficeAllowed () {
    return User.BACK_OFFICE_ALLOWED_ROLES.includes(this.role.code)
  }
}

User.BACK_OFFICE_ALLOWED_ROLES = [USER, TECHNICAL_ADMINISTRATOR, PROJECT_MANAGER, CCE]
export default User



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/User.js